module.exports = __webpack_public_path__ + "static/media/Products (8).0b11aee1.jpg";